module.exports = "https://static.energy5.com/_next/static/images/leftGridAboutImage-e6d8b98f4fc88d4af0cd0350cb234b18.jpg";